import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { loadState, reset } from './localStorage';
import { APP_API_KEY, STOP_API_CALLS } from '../components/Common/constant';
import {
  DEVICE_SIZE,
  SHOW_SIDEBAR,
  LOGIN_MODAL,
  SIGNUP_MODAL,
  ACTION_LOGIN,
  SESSION_TOKEN,
  USER_INFO,
  USER_DETAILS,
  USER_ACCESS,
  ACTION_LOGOUT,
  RESET,
  EVENT,
  EVENT_DETAILS,
  EVENT_FORMS_DETAILS,
  EVENT_TAB_LIST,
  EVENT_ALL_TICKETS,
  UPDATE_ACTIVE_TAB,
  EVENT_STRIPE_DETAILS,
  USER_DETAILS_QR,
  APPUSER_CATEGORIES_LIST,
  INTEREST_LIST,
  EVENT_WEBVIEW_DETAILS,
  EVENT_ADVT_DETAILS,
  REDIRECTING_CALLED_FROM,
  APPLY_COMMON_LOADER,
  INVOKE_NETWORK_MODAL,
  TIMEZONE_DETAILS,
  TICKETS_FOR_EVENT,
  MEETING_POPUP_DETAILS,
  FETCH_UNREAD_CHAT,
  UNAUTHORISED_API_CALLED,
  SITE_CONTROL
} from '../actions';
import {
  SchedulesDataReducers,
  SelectedScheduleDateReducer,
  scheduleTracksDataReducer,
  SelectedScheduleTrackReducer,
  trackSessionsDataReducer,
  sessionDetailsReducer,
  showSidebarReducer,
  showBackScreenReducer,
  openqaModalReducer,
  sessionqaDataReducer,
  sessionPolls,
  sessionPollsListModal,
  sessionPollsActionModal,
  sessionPollsResult,
  myBookedSchedule,
  myRatedSessionReducer,
  holdThisSessionDetailsReducer,
  liveQAReplyReducer,
  sessionVideoModalDetails,
  sessionRatingFormDataReducer,
  notSubmittedPollCountReducer,
  sessionsFilteredByTagsReducer,
  sessionColorsReducer
} from '../components/sessions/reducers';
import {
  chaptersDataReducer,
  CourseDataReducers,
  lessionsDataReducer,
  showBackScreenReducerKochify,
  showChaptersReducer,
  lessonqaDataReducer,
  openqaModalReducer_lesson,
  openQuizModalReducer_lesson,
  dynamicFormDataReducer,
  CourseDataReducers_ByUserAccess
} from '../components/mycourses/reducers';
import {
  myLiveSessionAccess,
  liveSessions,
  singleSessionDetails
} from '../components/livesessions/reducers';
import {
  overviewCourses,
  featuredCourses,
  allCourses,
  singleCoursesDetails,
  myCourseAccess,
  lessonPreviewModalReducer
} from '../components/course-overview/reducers';
import {
  allSpeakers,
  allSponsors,
  allExhibitors,
  seenEventAds
} from '../components/event-overview/reducers';
import { allPolls, pollActionModal } from '../components/polls/reducers';
import {
  speakerAttachments,
  speakerAttachmentsChanged,
  workingDynamicForm,
  productCategories,
  productSubCategories
} from '../components/myprofile/reducers';
import { appuserAccess, ownOrders } from '../components/mytickets/reducers';
import {
  mySessionDataReducers,
  mySessionqaDataReducer,
  showAceessSession,
  openqaReducer_session
} from '../components/mysessions/reducers';
import {
  myBookedExhibitor,
  allExhibitors_exb,
  exhibitor,
  exhibitorDetails,
  showOnlyExhibitorDetailsReducer,
  exbCountryReducer,
  exbSectorsReducer,
  exbCategoriesReducer
} from '../components/exhibitors/reducers';
import {
  isVSPopup,
  vsPopupContent,
  vsPopupHeight,
  vsPopupAddNote,
  vsPopupDetails
} from '../components/Common/vertical-sliding-popup/reducers';
import { hsPopupReducer } from '../components/Common/horizontal-sliding-popup/reducers';
// import {
//   chatThreadData,
//   chatData
// } from '../components/Common/chat-module/reducers';
import {
  myBookedSponsor,
  allSponsors_spn,
  sponsor,
  sponsorDetails,
  showOnlySponsorDetailsReducer
} from '../components/sponsors/reducers';
import {
  userData,
  openChatReducer,
  chatThreadData,
  chatData,
  viewUserReducer,
  attendeeListModalReducer,
  meetingModalReducer,
  timeoutListReducer,
  showBackScreenChat,
  suggestedUserDataReducer,
  openSuggestedFilterListReducer
} from '../components/userschat/reducers';
import { newsData, newsDetails, bookedNews } from '../components/news/reducers';
import {
  attendeeList,
  openAttendeeProfileReducer,
  showBackScreen,
  myBookmarkedUsers,
  openFilterListReducer,
  matchAttendeeCategoryReducer
} from '../components/attendee/reducers';
import {
  bookedSpeakers,
  speakersReducer,
  speakerDetailsReducer,
  showBackScreenSpeaker
} from '../components/speakers/reducers';
import {
  bookmarksByTypeReducer,
  bookmarksDataReducer
} from '../components/bookmarks/reducers';
import {
  communityDetails,
  commuCategoryList,
  showOnlyCommunityDetailsReducer,
  setCommunityDetails,
  postComment,
  setPostCommentView,
  postCommentModal,
  getPostDetails,
  postLikes,
  postCreateModal,
  communityNewMessage,
  communityOldMessage,
  selectedCommunityDetails
} from '../components/community-forum/reducers';
import {
  socialFeed,
  feedCommentModal,
  feedComment,
  socialImageSlider,
  postAddModal,
  feedLike
} from '../components/social/reducers';
import {
  gamificationChallenges,
  gamificationLeaderboard,
  gamificationShowpopup,
  showAward
} from '../components/gamification/reducers';
import { galleryImages } from '../components/gallery/reducers';
import {
  surveyRecord,
  selectedSurvey,
  showBackSurvey
} from '../components/survey/reducers';
import {
  shceduleDates,
  myAgenda,
  selectedDateAgenda,
  userMeetings
} from '../components/agenda/reducers';
import {
  appUserNotes,
  appuserNotes,
  noteDetailsReducer,
  showBackNotesScreenReducer
} from '../components/notes/reducers';
import { eventMaps, eventMapDetails } from '../components/maps/reducer';
import {
  eventFAQs,
  selectedFAQ,
  showBackFAQ
} from '../components/event-guide/reducers';
import {
  notificationReducer,
  selectedNotificationReducer,
  notifiedSocialPostDetailsReducer,
  notificationUnreadCountReducer,
  notifiedCommunityDetailsReducer,
  notifiedChatDetailsReducer,
  outreachModalReducer
} from '../components/notifications/reducers';
import {
  globalSearchReducer,
  latestGlobalSearchReducer,
  selectedGlobalSearchReducer
} from '../components/global-search/reducer';
import {
  myScanReducer,
  selectedScanItemReducer,
  selectedScanLinkedItemReducer
} from '../components/myscans/reducers';

var loginReducer = (state = true, action) => {
  // need to change it to false
  var state = loadState();

  if (state == undefined) {
    state = {
      isLoggedIn: false
    };
  }

  if (action.type === ACTION_LOGIN) {
    state.isLoggedIn = action.payload;
  }

  if (action.type === ACTION_LOGOUT) {
    state.isLoggedIn = action.payload;
  }

  return state.isLoggedIn;
};
const unauthorisedApiCalled = (state = false, action) => {
  if (action.type == UNAUTHORISED_API_CALLED) return action.payload;
  return state;
};
var tokensReducer = (state = {}, action) => {
  var state = loadState();

  if (
    state == undefined ||
    state.session == undefined ||
    state.session.apiKey === ''
  ) {
    state = {
      session: {
        apiKey: APP_API_KEY,
        sessionToken: '',
        eventid: '',
        eventname: '',
        eventtimezone: '',
        seocode: '',
        udfid: '',
        emailid: '',
        firstname: '',
        lastname: '',
        userid: '',
        isadmin: false
      }
    };
  } else {
    switch (action.type) {
      case SESSION_TOKEN:
        if (action.payload.session_token) {
          state.session.sessionToken = action.payload.session_token;
          state.session.udfid = action.payload.id;
        }
        break;

      case USER_INFO:
        state.session.userid = action.payload.appuserid ?? '';
        state.session.emailid = action.payload.email ?? '';
        state.session.firstname = action.payload.firstname ?? '';
        state.session.lastname = action.payload.lastname ?? '';
        state.session.isadmin = action.payload.isadmin ?? false;
        break;

      case EVENT:
        state.session.eventid = action.payload.eventid ?? '';
        state.session.eventname = action.payload.eventname ?? '';
        state.session.eventtimezone = action.payload.eventtimezone ?? '';
        state.session.seocode = action.payload.seocode ?? '';
        break;

      case ACTION_LOGOUT:
        state.session.sessionToken = '';
        state.session.udfid = '';
        state.session.emailid = '';
        state.session.firstname = '';
        state.session.lastname = '';
        state.session.userid = '';
        state.session.isadmin = false;
        reset();
        break;

      case RESET:
        reset();
        break;

      default:
        break;
    }
  }

  return state.session;
};
var eventData = (state = {}, action) => {
  if (action.type === EVENT) {
    return action.payload;
  }
  return state;
};
var userDetails = (state = {}, action) => {
  if (action.type === USER_DETAILS) {
    return action.payload;
  }
  return state;
};
var userAccess = (state = {}, action) => {
  if (action.type === USER_ACCESS) {
    return action.payload;
  }
  return state;
};
var deviceSize = (state = {}, action) => {
  if (action.type === DEVICE_SIZE) {
    return action.payload;
  }
  return state;
};
var showSidebar = (state = false, action) => {
  if (action.type === SHOW_SIDEBAR) {
    return action.payload;
  }
  return state;
};
var loginModal = (state = {}, action) => {
  if (action.type === LOGIN_MODAL) {
    return action.payload;
  }
  return state;
};
var signupModal = (state = {}, action) => {
  if (action.type === SIGNUP_MODAL) {
    return action.payload;
  }
  return state;
};
var eventDetails = (state = {}, action) => {
  if (action.type === EVENT_DETAILS) {
    return action.payload;
  }
  return state;
};
var eventForms = (state = {}, action) => {
  if (action.type === EVENT_FORMS_DETAILS) {
    return action.payload;
  }
  return state;
};
var eventTabs = (state = {}, action) => {
  if (action.type === EVENT_TAB_LIST) {
    return action.payload;
  }
  return state;
};
var eventTickets = (state = {}, action) => {
  if (action.type === EVENT_ALL_TICKETS) {
    return action.payload;
  }
  return state;
};
const redirectingCallReducer = (state = '', action) => {
  if (action.type == REDIRECTING_CALLED_FROM) {
    return action.payload;
  }
  return state;
};
const activeTab = (state = null, action) => {
  if (action.type === UPDATE_ACTIVE_TAB) {
    return action.payload;
  }
  return state;
};
const stripeDetails = (state = {}, action) => {
  if (action.type === EVENT_STRIPE_DETAILS) {
    return action.payload;
  }
  return state;
};
const userQrDetails = (state = {}, action) => {
  if (action.type === USER_DETAILS_QR) {
    return action.payload;
  }
  return state;
};
const appuserCategories = (state = {}, action) => {
  if (action.type === APPUSER_CATEGORIES_LIST) {
    return action.payload;
  }
  return state;
};
const interestList = (state = {}, action) => {
  if (action.type === INTEREST_LIST) {
    return action.payload;
  }
  return state;
};
const webviewDetails = (state = {}, action) => {
  if (action.type == EVENT_WEBVIEW_DETAILS) {
    return action.payload;
  }
  return state;
};
const advtDetails = (state = [], action) => {
  if (action.type == EVENT_ADVT_DETAILS) {
    return action.payload;
  }
  return state;
};
const commonLoaderReducer = (state = false, action) => {
  if (action.type == APPLY_COMMON_LOADER) {
    return action.payload;
  }
  return state;
};
const networkingReducer = (state = false, action) => {
  if (action.type === INVOKE_NETWORK_MODAL) {
    return action.payload;
  }
  return state;
};
const timezoneDetails = (state = {}, action) => {
  if (action.type == TIMEZONE_DETAILS) {
    return action.payload;
  }
  return state;
};
const ticketsForEvent = (state = {}, action) => {
  if (action.type == TICKETS_FOR_EVENT) {
    return action.payload;
  }
  return state;
};
const meetingPopupReducer = (state = {}, action) => {
  if (action.type == MEETING_POPUP_DETAILS) {
    return action.payload;
  }
  return state;
};
const unreadChatCountReducer = (state = {}, action) => {
  if (action.type == FETCH_UNREAD_CHAT) return action.payload;
  return state;
};
const siteControlReducer = (state = 'allow', action) => {
  if (action.type === SITE_CONTROL) return action.payload;
  return state;
};

const stopApiCalls = (state = STOP_API_CALLS) => {
  return state;
};

const rootReducer = combineReducers({
  form: formReducer,
  isLoggedIn: loginReducer,
  session: tokensReducer,
  deviceSize,
  showSidebar,
  loginModal,
  signupModal,
  stopApiCalls,
  unauthorisedApiCalled,

  // Common
  eventDataOnly: eventData,
  eventDetails,
  eventForms,
  allPolls,
  pollActionModal,
  userDetails,
  userAccess,
  eventTabs,
  eventTickets,
  activeTab,
  stripeDetails,
  isVSPopup,
  vsPopupContent,
  vsPopupHeight,
  vsPopupAddNote,
  appuserCategories,
  interestList,
  vsPopupDetails,
  redirectCalledFrom: redirectingCallReducer,
  commonLoaderReducer,
  networkingReducer,
  timezoneDetails,
  hsPopupReducer,
  ticketsForEvent,
  meetingPopupReducer,
  unreadChatCountReducer,
  siteControlReducer,

  // My Profile
  speakerAttachments,
  speakerAttachmentsChanged,
  workingDynamicForm,
  productCategories,
  productSubCategories,

  // Eventify
  // Event overview
  allSpeakers,
  allSponsors,
  allExhibitors,
  userQrDetails,

  // Event overview
  appuserAccess,
  ownOrders,
  seenEventAds,

  // Sessions
  SchedulesDataReducers,
  SelectedScheduleDateReducer,
  scheduleTracksDataReducer,
  SelectedScheduleTrackReducer,
  trackSessionsDataReducer,
  sessionDetailsReducer,
  showSidebarReducer,
  showBackScreenReducer,
  openqaModalReducer,
  sessionqaDataReducer,
  sessionPolls,
  sessionPollsListModal,
  sessionPollsActionModal,
  sessionPollsResult,
  myBookedSchedule,
  myRatedSessionReducer,
  holdThisSession: holdThisSessionDetailsReducer,
  liveQAReplyReducer,
  sessionVideoModalDetails,
  sessionRatingFormDataReducer,
  notSubmittedPollCountReducer,
  sessionsFilteredByTagsReducer,
  sessionColorsReducer,

  // Speakers
  bookedSpeakers,
  speakersReducer,
  speakerDetailsReducer,
  showBackScreenSpeaker,

  // Bookmarks
  bookmarksByTypeReducer,
  bookmarksDataReducer,

  // Gallery
  galleryImages,

  // Survey
  surveyRecord,
  selectedSurvey,
  showBackSurvey,

  // My Agenda
  shceduleDates,
  myAgenda,
  selectedDateAgenda,
  userMeetings,

  // Kochify
  // Course overview
  overviewCourses,
  featuredCourses,
  allCourses,
  singleCoursesDetails,
  myCourseAccess,
  lessonPreviewModalReducer,

  // My Courses
  CourseDataReducers,
  chaptersDataReducer,
  lessionsDataReducer,
  showBackScreenReducerKochify,
  showChaptersReducer,
  openqaModalReducer_lesson,
  lessonqaDataReducer,
  openQuizModalReducer_lesson,
  dynamicFormDataReducer,
  CourseDataReducers_ByUserAccess,

  // Live Session
  myLiveSessionAccess,
  liveSessions,
  singleSessionDetails,

  // My Sessions
  mySessionDataReducers,
  mySessionqaDataReducer,
  showAceessSession,
  openqaReducer_session,

  // Chat
  userData,
  openChatReducer,
  chatThreadData,
  chatData,
  viewUserReducer,
  attendeeListModalReducer,
  timeoutListReducer,
  meetingModalReducer,
  showBackScreenChat,
  openFilterListReducer,
  suggestedUserDataReducer,
  openSuggestedFilterListReducer,

  // Attendee
  attendeeList,
  openAttendeeProfileReducer,
  showBackScreenAtte: showBackScreen,
  myBookmarkedUsers,
  matchAttendeeCategoryReducer,

  // News
  newsData,
  newsDetails,
  bookedNews,

  // Exhibitors
  myBookedExhibitor,
  allExhibitors_exb,
  exhibitor,
  exhibitorDetails,
  appUserNotes,
  showOnlyExhibitorDetailsReducer,
  exbCountryReducer,
  exbSectorsReducer,
  exbCategoriesReducer,

  // Sponsors
  myBookedSponsor,
  allSponsors_spn,
  sponsor,
  sponsorDetails,
  showOnlySponsorDetailsReducer,

  // Community Forum
  communityDetails,
  commuCategoryList,
  showOnlyCommunityDetailsReducer,
  setCommunityDetails,
  postComment,
  setPostCommentView,
  postCommentModal,
  getPostDetails,
  postLikes,
  postCreateModal,
  communityNewMessage,
  communityOldMessage,
  selectedCommunityDetails,

  //Social Feed
  socialFeed,
  feedComment,
  feedCommentModal,
  socialImageSlider,
  postAddModal,
  feedLike,

  // Gamification
  gamificationChallenges,
  gamificationLeaderboard,
  gamificationShowpopup,
  showAward: showAward,

  // Notes
  appuserNotes,
  noteDetailsReducer,
  showBackNotesScreenReducer,

  // webview
  webviewDetails,

  // advertisements
  advtDetails,

  // maps
  eventMaps,
  eventMapDetails,

  // event guide
  eventFAQs,
  selectedFAQ,
  showBackFAQ,

  // notifications
  notificationReducer,
  selectedNotificationReducer,
  notifiedSocialPostDetailsReducer,
  notificationUnreadCountReducer,
  notifiedCommunityDetailsReducer,
  notifiedChatDetailsReducer,
  outreachModalReducer,

  // global search
  globalSearchReducer,
  latestGlobalSearchReducer,
  selectedGlobalSearchReducer,

  // my scans
  myScanReducer,
  selectedScanItemReducer,
  selectedScanLinkedItemReducer
});

// put reducers in comma seperated '' inside this array to store them in locastorage
const persistThisReducers = [];

export default rootReducer;
export { persistThisReducers };
